(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[264],{

/***/ "qsa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/sections/Sections.jsx + 3 modules
var Sections = __webpack_require__("tCJK");

// CONCATENATED MODULE: ./src/client/components/lines/sections-line/SectionsLine.jsx


var __jsx = react_default.a.createElement;


var SectionsLine_SectionsLine = function SectionsLine(_ref) {
  var children = _ref.children,
      _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? [] : _ref$lines;
  return __jsx(Sections["a" /* Sections */], {
    navItems: lines.map(function (l) {
      return l.props.name;
    }),
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    className: "pt-10"
  }, children);
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/sections/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (SectionsLine_SectionsLine);

/***/ })

}]);